// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - posthog-react-native is only available in React Native environments
import { PostHog } from "posthog-react-native"

import { FeatureFlagClient, FeatureFlagValue } from "../FeatureFlagClient"

export class PostHogNativeClient implements FeatureFlagClient {
  private posthog: any = null
  private ready = false
  private callbacks: (() => void)[] = []

  async init(apiKey: string): Promise<void> {
    try {
      const apiHost =
        process.env.EXPO_PUBLIC_POSTHOG_API_HOST || "https://app.posthog.com"

      this.posthog = new PostHog(apiKey, {
        host: apiHost,
      })

      // Listen for feature flags loaded
      this.posthog.onFeatureFlags(() => {
        this.ready = true
        this.callbacks.forEach((callback) => callback())
        this.callbacks = []
      })

      // Force initial load
      await this.posthog.reloadFeatureFlags()
    } catch (error) {
      console.error("Failed to initialize PostHog:", error)
    }
  }

  isEnabled(flagKey: string): boolean {
    if (!this.posthog || !this.ready) return false
    return this.posthog.isFeatureEnabled(flagKey) === true
  }

  getVariant(flagKey: string): FeatureFlagValue {
    if (!this.posthog || !this.ready) return false
    return this.posthog.getFeatureFlag(flagKey) as FeatureFlagValue
  }

  onFlagsLoaded(callback: () => void): void {
    if (this.ready) {
      callback()
    } else {
      this.callbacks.push(callback)
    }
  }

  async reload(): Promise<void> {
    if (this.posthog) {
      await this.posthog.reloadFeatureFlags()
    }
  }

  identify(userId: string, properties: Record<string, unknown> = {}): void {
    if (this.posthog) {
      this.posthog.identify(userId, properties)
    }
  }

  shutdown(): void {
    if (this.posthog) {
      this.posthog.reset()
    }
    this.ready = false
    this.callbacks = []
  }

  isReady(): boolean {
    return this.ready
  }
}
